import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5f8a2d44&scoped=true&"
import script from "./detail.js?vue&type=script&lang=js&"
export * from "./detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5f8a2d44&lang=scss&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a2d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8a2d44')) {
      api.createRecord('5f8a2d44', component.options)
    } else {
      api.reload('5f8a2d44', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5f8a2d44&scoped=true&", function () {
      api.rerender('5f8a2d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersales/sellerList/detail.vue"
export default component.exports